export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    styles() {
      if (!this.src) return {};
      if (/x-oss-process=/.test(this.src)) return {
        backgroundImage: `url(${this.src})`
      };
      const src = /http/.test(this.src) ? `${this.src.split('?')[0]}?x-oss-process=video/snapshot,t_1000,w_80,h_80,f_jpg,m_fast&t=${new Date().getTime()}` : this.src;
      const backgroundImage = `url(${src})`;
      return {
        backgroundImage
      };
    }
  },
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};